export default function Download() {
  return (
    <section id="download" className="relative">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        {/* Left Area - Image with Text Overlay */}
        <div className="relative overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/39e6a54e1cb2b6500198ab125019fa8b.jpg"
            alt="STYLINE VPN Devices"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/80 to-blue-600/80"></div>
          
          <div className="absolute bottom-16 left-16">
            <div className="mb-4">
              <span className="text-white text-xs font-semibold tracking-[2px] uppercase">
                AVAILABLE NOW
              </span>
            </div>
            <h2 className="leading-tight">
              <div className="text-6xl font-extrabold text-white mb-1">Download</div>
              <div className="text-7xl font-extrabold text-white mb-1" style={{ textShadow: '0 0 30px rgba(6, 182, 212, 0.8)' }}>
                STYLINE VPN
              </div>
              <div className="text-6xl font-extrabold text-white">Today</div>
            </h2>
          </div>
        </div>

        {/* Right Area - Content */}
        <div className="bg-white flex items-center justify-center px-16 py-20">
          <div className="max-w-md text-center">
            <h2 className="text-5xl font-bold text-gray-900 mb-3">Get Started in</h2>
            <h2 className="text-5xl font-bold text-gray-900 mb-12">Three Simple Steps</h2>

            <div className="text-lg text-gray-700 leading-relaxed space-y-6 mb-16">
              <p>
                <span className="font-bold text-cyan-600">1.</span> Download the app for your device
              </p>
              <p>
                <span className="font-bold text-cyan-600">2.</span> Create your secure account
              </p>
              <p>
                <span className="font-bold text-cyan-600">3.</span> Connect and browse privately
              </p>
            </div>

            <div className="flex items-center justify-center gap-5">
              <button className="px-8 py-4 bg-gray-900 text-white font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 hover:-translate-y-1 flex items-center gap-3 whitespace-nowrap">
                <i className="ri-apple-fill text-xl"></i>
                For macOS
                <i className="ri-arrow-right-line"></i>
              </button>
              <button className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-full hover:bg-blue-700 transition-all duration-300 hover:-translate-y-1 flex items-center gap-3 whitespace-nowrap">
                <i className="ri-apple-fill text-xl"></i>
                For iOS
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
